import type { SVGProp } from './types';

export const close = (props: SVGProp) => (
  <svg
    width={props.width || '24'}
    height={props.height || '24'}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    {...props}
  >
    <path
      d="m13.4099 11.9999 6.3-6.28996c.1883-.1883.2941-.4437.2941-.71 0-.2663-.1058-.52169-.2941-.71-.1883-.1883-.4437-.29409-.71-.29409-.2663 0-.5217.10579-.71.29409l-6.29 6.29996-6.28996-6.29996c-.1883-.1883-.4437-.29409-.71-.29409-.2663 0-.5217.10579-.71.29409-.1883.18831-.29409.4437-.29409.71 0 .2663.10579.5217.29409.71l6.29996 6.28996-6.29996 6.29c-.09373.093-.16812.2036-.21889.3255-.05077.1218-.07691.2525-.07691.3845 0 .1321.02614.2628.07691.3846.05077.1219.12516.2325.21889.3254.09296.0938.20356.1682.32542.2189.12186.0508.25257.0769.38458.0769.13201 0 .26272-.0261.38458-.0769.12186-.0507.23246-.1251.32542-.2189l6.28996-6.3 6.29 6.3c.093.0938.2036.1682.3255.2189.1218.0508.2525.0769.3845.0769.1321 0 .2628-.0261.3846-.0769.1219-.0507.2325-.1251.3254-.2189.0938-.0929.1682-.2035.2189-.3254.0508-.1218.0769-.2525.0769-.3846 0-.132-.0261-.2627-.0769-.3845-.0507-.1219-.1251-.2325-.2189-.3255l-6.3-6.29Z"
      fill="currentColor"
    />
  </svg>
);
